var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('input',{attrs:{"type":"text","placeholder":"Typ de naam van het boek of de auteur"}}),_c('Dash'),_c('Nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }